import { useQuery } from '@tanstack/react-query';

import { errorHandler } from 'utils/errors';

import { getReferralByCode } from 'lib/api/community';

function useGetCommunity(code: string) {
  const query = useQuery({
    queryKey: ['community', code],
    enabled: false,
    queryFn: async () => {
      try {
        const response = await getReferralByCode(code);

        if (!response.data) {
          throw new Error(
            'Something is terribly wrong, please contact our administrator',
          );
        }

        const { data } = response;

        return data.data;
      } catch (error) {
        errorHandler(error, 'Failed to get community, unhandled error');
        return undefined;
      }
    },
    retry: false,
  });

  return query;
}

export default useGetCommunity;
